export default "__VITE_ASSET__015c2317__"